import { create } from 'zustand';

const initialState = { selectedView: 'presence' };

const useMonitoringState = create((set) => ({
  ...initialState,
  updateState: (newState) => set((state) => ({ ...state, ...newState })),
  resetState: () => set(() => ({ ...initialState })),
}));

export default useMonitoringState;
